import { render } from "./StarRatingInline.vue?vue&type=template&id=538daf05&scoped=true&ts=true"
import script from "./StarRatingInline.vue?vue&type=script&lang=ts"
export * from "./StarRatingInline.vue?vue&type=script&lang=ts"

import "./StarRatingInline.vue?vue&type=style&index=0&id=538daf05&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538daf05"]])

export default __exports__